import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

const stripePromise = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
    ? loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
    : null;

const CARD_ELEMENT_OPTIONS = {
    style: {
        base: {
            fontSize: '15px',
            color: '#0f3c4b',
            fontFamily: 'inherit',
            '::placeholder': { color: '#aab8c8' },
        },
        invalid: { color: '#e0245e' },
    },
    hidePostalCode: true,
};

function CardForm({ onSuccess, onCancel }) {
    const stripe = useStripe();
    const elements = useElements();
    const [error, setError] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        if (!stripe || !elements) return;

        setLoading(true);
        setError(null);

        const { paymentMethod, error: stripeError } = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement),
        });

        if (stripeError) {
            setError(stripeError.message);
            setLoading(false);
            return;
        }

        onSuccess({
            paymentMethodId: paymentMethod.id,
            brand: paymentMethod.card.brand,
            last4: paymentMethod.card.last4,
            expMonth: paymentMethod.card.exp_month,
            expYear: paymentMethod.card.exp_year,
        });
        setLoading(false);
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="credit-card-element-wrapper">
                <CardElement options={CARD_ELEMENT_OPTIONS} />
            </div>
            {error && <div className="credit-card-error">{error}</div>}
            <div className="credit-card-popup-actions">
                <button type="button" className="credit-card-cancel-btn" onClick={onCancel} disabled={loading}>
                    Cancel
                </button>
                <button type="submit" className="credit-card-save-btn" disabled={!stripe || loading}>
                    {loading ? 'Saving…' : 'Save Card'}
                </button>
            </div>
        </form>
    );
}

export default function CreditCardPopup({ onSuccess, onCancel }) {
    return (
        <div className="credit-card-backdrop" onClick={onCancel}>
            <div className="credit-card-popup" onClick={e => e.stopPropagation()}>
                <div className="credit-card-popup-header">
                    <span className="credit-card-popup-title">Add Credit Card</span>
                    <button className="credit-card-close-btn" onClick={onCancel}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                    </button>
                </div>
                <Elements stripe={stripePromise}>
                    <CardForm onSuccess={onSuccess} onCancel={onCancel} />
                </Elements>
            </div>
        </div>
    );
}
